import { generateId } from "../utils/helpers";

export const QUERY_FIELD_PARAM_MAP = {
  pageDescription: "Page_Description",
  selector: "Object_Xpath",
  outerHtml: "outerhtml",
  TestData: "TestData",
  action: "Action",
  pageUrl: "pageurl",
};

export const QUERY_FIELD_OPTIONS = [
  { label: "Page Description", value: "pageDescription" },
  { label: "Selector / Locator", value: "selector" },
  { label: "Outer HTML", value: "outerHtml" },
  { label: "Test Data", value: "TestData" },
  { label: "Action", value: "action" },
  { label: "Page URL", value: "pageUrl" },
];

export const OPERATOR_OPTIONS = [
  { label: "contains", value: "contains" },
  { label: "equals", value: "equals" },
  { label: "starts with", value: "startsWith" },
  { label: "ends with", value: "endsWith" },
  { label: "does not contain", value: "notContains" },
];


export const DEFAULT_CONDITION = {
  id: generateId(),
  field: "pageDescription",
  operator: "contains",
  value: "",
  logicalOp: "AND",
  useSourceValue: true,
  attributeKey: [],
};
